module.exports = __webpack_public_path__ + "img/ereszkalkulator_26_minoseg_standard_fekete.18bd1df3.png";